export class CommandRegistry {
  constructor(editor) {
    this.editor = editor;
    this.commands = new Map();
  }

  register(name, command) {
    this.commands.set(name, command);
  }

  execute(name, payload) {
    const cmd = this.commands.get(name);
    if (!cmd) return;

    // For undo/redo, execute directly without update wrapper
    if (name === "undo" || name === "redo") {
      cmd(payload);
      return;
    }

    // Execute command with update wrapper
    this.editor.update(() => cmd(payload));

    // Save snapshot after execute
    const snapshot = this.editor.createSnapshot();
    this.editor.history?.push(snapshot);
  }
}
